import { render, staticRenderFns } from "./NewCase.vue?vue&type=template&id=4dfa3dfa&scoped=true&"
import script from "./NewCase.vue?vue&type=script&lang=js&"
export * from "./NewCase.vue?vue&type=script&lang=js&"
import style0 from "./NewCase.vue?vue&type=style&index=0&id=4dfa3dfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfa3dfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dfa3dfa')) {
      api.createRecord('4dfa3dfa', component.options)
    } else {
      api.reload('4dfa3dfa', component.options)
    }
    module.hot.accept("./NewCase.vue?vue&type=template&id=4dfa3dfa&scoped=true&", function () {
      api.rerender('4dfa3dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/multiplePeopleCase/components/NewCase.vue"
export default component.exports